module.exports = __webpack_public_path__ + "img/m_ic_sns_kakao.eb84000a.png";